import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/components/index'
import AboutUs from '@/components/aboutUs'
import ActivitieDetails from '@/components/activitieDetails'
import Activetys from '@/components/activitys'
import ProductDetails from '@/components/productDetails'
import Products from '@/components/products'
import News from '@/components/news'
import Album from '@/components/album'
import NewsDetails from '@/components/newsDetails'
import User from '@/components/userCenter'
import OrderList from '@/components/orderList'
import OrderDetail from '@/components/orderDetail'
import Address from '@/components/address'
import Car from '@/components/car'
import Score from '@/components/score'
import Reward from '@/components/reward'
import ProOrderConfirm from '@/components/proOrderConfirm'
import ProOrderList from '@/components/proOrderList'
import ProOrderDetail from '@/components/proOrderDetail'
import Feedback from '@/components/feedback'
import ActiveOrderConfirm from '@/components/activeOrderConfirm'

import { Message } from "element-ui"
import eventVue from '@/bus.js'
import axios from 'axios'
import store from "../store/index.js"
axios.defaults.baseURL = 'http://www.tindoe.com/apiserver'

function getUrlParam (name) {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
  let url = window.location.href.split('#')[0]
  let search = url.split('?')[1]
  if (search) {
    var r = search.substr(0).match(reg)
    if (r !== null) return unescape(r[2])
    return null
  } else {
    return null
  }
}

Vue.use(Router)
let router = new Router({
  //mode: 'history',
  routes: [
    {
      path: '/',
      redirect() {
        return '/index'
      }
    },
    {
      path: '/index',
      name: 'index',
      component: Index
    },
    {
      path: '/aboutUs',
      name: 'aboutUs',
      component: AboutUs
    },
    {
      path: '/activitieDetails/:id',
      name: 'activitieDetails',
      component: ActivitieDetails
    },
    {
      path: '/activetys',
      name: 'activetys',
      component: Activetys
    },
    {
      path: '/activetys/:id',
      name: 'activetys',
      component: Activetys
    },
    {
      path: '/productDetails/:id',
      name: 'productDetails',
      component: ProductDetails
    },
    {
      path: '/products/:id',
      name: 'products',
      component: Products
    },
    {
      path: '/products',
      name: 'products',
      component: Products
    },
    {
      path: '/news',
      name: 'news',
      component: News
    },
    {
      path: '/album',
      name: 'album',
      component: Album
    },
    {
      path: '/newsDetails/:id',
      name: 'newsDetails',
      component: NewsDetails
    },
    {
      path: '/user',
      name: 'user',
      component: User
    },
    {
      path: '/orderList',
      name: 'orderList',
      component: OrderList
    },
    {
      path: '/orderDetails/:id',
      name: 'orderDetails',
      component: OrderDetail
    },
    {
      path: '/address',
      name: 'address',
      component: Address
    },
    {
      path: '/car',
      name: 'car',
      component: Car
    },
    {
      path: '/score',
      name: 'score',
      component: Score
    },
    {
      path: '/reward',
      name: 'reward',
      component: Reward
    },
    {
      path: '/proOrderConfirm',
      name: 'proOrderConfirm',
      component: ProOrderConfirm
    },
    {
      path: '/proOrderList',
      name: 'proOrderList',
      component: ProOrderList
    },
    {
      path: '/feedback',
      name: 'feedback',
      component: Feedback
    },
    {
      path: '/activeOrderConfirm',
      name: 'activeOrderConfirm',
      component: ActiveOrderConfirm
    },
    {
      path: '/proOrderDetail/:id',
      name: 'proOrderDetail',
      component: ProOrderDetail
    },
  ]
})

router.beforeEach((to, from, next) => {
  if(to.name == 'newsDetails'){
    eventVue.$emit("navSwitch",'news')
  }else if(to.name == 'productDetails'){
    eventVue.$emit("navSwitch",'product')
  }else if(to.name == 'activitieDetails'){
    eventVue.$emit("navSwitch",'activety')
  }else {
    eventVue.$emit("navSwitch",'')
  }
  console.log(sessionStorage.getItem("userId"))
  //debugger
  window.scrollTo(0,0);
  let pathCode = getUrlParam('code')
  if(pathCode){
    let userId = sessionStorage.getItem("userId")
    if (userId) {
      store.state.userId = userId;
      next()
    }else{
      axios.get('/api/wechatUser/getWechatWebOpenId?code='+pathCode).then(res =>{
        if (res.code == 0) {
          sessionStorage.setItem("userId", res.data)
          store.state.userId = res.data;
        }else{
          Message(res.message)
          window.location.replace(window.location.origin)
        }
        next()
      }).catch(err=>{})
    }
  }else{
    next()
  }
})

// router.beforeEach((to, from, next) => {
//   if(getUrlParam('code'))

//     //next();
// })

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js